import { render } from "./LojasValidacaoJetoil.vue?vue&type=template&id=60d3ca3c&scoped=true&ts=true"
import script from "./LojasValidacaoJetoil.vue?vue&type=script&lang=ts"
export * from "./LojasValidacaoJetoil.vue?vue&type=script&lang=ts"

import "./LojasValidacaoJetoil.vue?vue&type=style&index=0&id=60d3ca3c&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d3ca3c"]])

export default __exports__